import * as $ from "jquery";
import Handlebars from "Handlebars";
import DeliveryAddressComponent from "./components.deliveryaddress";

export default class CustomerDetailsComponent {
    constructor() {
        this.detailsTemplateSelector = "#customer-detail-template";
        this.detailsResultSelector = "#customer-modal-info";
        this.detailsResultTemplate = null;
        this.deliveryAddress = new DeliveryAddressComponent();
    }

    init() {
        let instance = this;

        const detailsTemplate = $(this.detailsTemplateSelector).html();
        if (detailsTemplate !== undefined) {
            this.detailsResultTemplate = Handlebars.compile(detailsTemplate);
        }

        this.bindModalEvents();
    }

    bindModalEvents() {
        let instance = this;

        $(document).on('click', '.js-open-address-modal', function () {
            const customerNumber = $(this).attr('data-customer');
            const marketId = $(this).attr('data-marketid');
            instance.deliveryAddress.customerDetailsContent = $(instance.deliveryAddress.modalSelector).html();
            instance.deliveryAddress.loadAddressModal(customerNumber, marketId);
        });

        $(document).on('click', '.js-close-address-modal', function () {
            if (instance.deliveryAddress.customerDetailsContent) {
                $(instance.deliveryAddress.modalSelector).html(instance.deliveryAddress.customerDetailsContent);
                instance.deliveryAddress.customerDetailsContent = null;
                instance.showCustomerLoading(instance);
                instance.getCustomerDetails(
                    instance.deliveryAddress.currentCustomerNumber,
                    instance.deliveryAddress.currentMarketId,
                    instance
                );
            }
        });

        $(document).on('click', '.js-close-edit-modal', function () {
            instance.deliveryAddress.loadAddressModal(
                instance.deliveryAddress.currentCustomerNumber,
                instance.deliveryAddress.currentMarketId
            );
        });

        $(document).on('click', '.js-show-active-customer', function () {
            const customerNumber = $(this).attr('data-id');
            const marketId = $(this).attr('data-marketid');
            instance.getCustomerDetails(customerNumber, marketId, instance);
        });
    }

    showCustomerLoading(instance) {
        $('#customer-modal-info').append(`<div id="customer-card-overlay"><span class="spinner"></span></div>`);
    }

    hideCustomerLoading(instance) {
        $('#customer-card-overlay').remove();
    }

    getCustomerDetails(customerNumber, marketId, instance) {
        if ($("#shipping-address-section").attr('data-customer') != customerNumber) {
            instance.showCustomerLoading(instance);
        }

        axios({
            method: 'post',
            url: "/customer/getcustomer",
            data: { customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            console.log(response.data)
            instance.showCustomerDetails(response.data, instance);
        }).catch(function (response) {
            console.log(response);
        });
    }

    showCustomerDetails(data, instance) {
        $(instance.detailsResultSelector).html(instance.detailsResultTemplate(data));
        instance.hideCustomerLoading(instance);

        instance.deliveryAddress.init();

        $('.js-signup-WKNO').off().on('click', function (e) {
            var customerNumber = $(this).attr('data-customer');
            var marketId = $(this).attr('data-marketid');
            $('.js-signup-WKNO').attr('disabled', '');
            instance.signupWKNO(instance, customerNumber, marketId);
        });

        $('.js-save-fixit').off().on('click', function () {
            instance.updateFixitId(instance);
        });

        $('#exclude-gwp').off().on('click', function () {
            instance.updateGWP(instance);
        });

        $('#fixit-id').off().on('focus', function () {
            $('#error-save-fixit').html("");
            $('#fixit-id').val('');
        });
    }

    updateCustomer(instance) {
        let customerNumber = $('.update-customer #customernumber').val();
        let email = $('.update-customer #email').val();
        let organisationnumber = $('.update-customer #organisationnumber').val();
        let password = $('.update-customer #password').val();

        axios({
            method: 'post',
            url: "/customer/updatecustomer",
            data: { customerNumber: customerNumber, email: email, organisationNumber: organisationnumber, password: password }
        }).then(function (response) {
            $('.update-customer #result').html(response.data);
        }).catch(function (response) {
            console.log(response);
        });
    }

    updateFixitId(instance) {
        let customerNumber = $('.js-save-fixit').attr('data-customer');
        let fixit = $('#fixit-id').val();
        let marketId = $('#shipping-address-section').attr('data-marketid');

        $('#fixit-id').css('opacity', '0.4');

        axios({
            method: 'post',
            url: "/customer/updatefixit",
            data: { customerNumber: customerNumber, marketId: marketId, fixit: fixit }
        }).then(function (response) {
            if (response.data == "False") {
                $('#error-save-fixit').html("Fixit id upptaget");
            } else {
                $('#fixit-id').css('opacity', '1.0');
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    updateGWP(instance) {
        let customerNumber = $('.js-save-fixit').attr('data-customer');
        let gwp = $('#exclude-gwp').is(":checked");
        let marketId = $('#shipping-address-section').attr('data-marketid');

        axios({
            method: 'post',
            url: "/customer/updategwp",
            data: { customerNumber: customerNumber, marketId: marketId, gwp: gwp }
        }).then(function (response) {
        }).catch(function (response) {
            console.log(response);
        });
    }
}